<div class="w-100">
  <h4 class="m-0">
    Cargando datos de {{menu.label | translate | lowercase}}...
    <div class="spinner-border text-secondary" role="status" style="height: 13px; width: 13px">
      <span class="sr-only"></span>
    </div>
  </h4>
</div>
